{
  "version": "2.0",
  "metadata": {
    "apiVersion": "2017-07-25",
    "endpointPrefix": "amplify",
    "jsonVersion": "1.1",
    "protocol": "rest-json",
    "serviceAbbreviation": "Amplify",
    "serviceFullName": "AWS Amplify",
    "serviceId": "Amplify",
    "signatureVersion": "v4",
    "signingName": "amplify",
    "uid": "amplify-2017-07-25"
  },
  "operations": {
    "CreateApp": {
      "http": {
        "requestUri": "/apps"
      },
      "input": {
        "type": "structure",
        "required": [
          "name"
        ],
        "members": {
          "name": {},
          "description": {},
          "repository": {},
          "platform": {},
          "iamServiceRoleArn": {},
          "oauthToken": {},
          "accessToken": {},
          "environmentVariables": {
            "shape": "S9"
          },
          "enableBranchAutoBuild": {
            "type": "boolean"
          },
          "enableBasicAuth": {
            "type": "boolean"
          },
          "basicAuthCredentials": {},
          "customRules": {
            "shape": "Sf"
          },
          "tags": {
            "shape": "Sl"
          },
          "buildSpec": {},
          "enableAutoBranchCreation": {
            "type": "boolean"
          },
          "autoBranchCreationPatterns": {
            "shape": "Sq"
          },
          "autoBranchCreationConfig": {
            "shape": "Ss"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "app"
        ],
        "members": {
          "app": {
            "shape": "Sx"
          }
        }
      }
    },
    "CreateBranch": {
      "http": {
        "requestUri": "/apps/{appId}/branches"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {},
          "description": {},
          "stage": {},
          "framework": {},
          "enableNotification": {
            "type": "boolean"
          },
          "enableAutoBuild": {
            "type": "boolean"
          },
          "environmentVariables": {
            "shape": "S9"
          },
          "basicAuthCredentials": {},
          "enableBasicAuth": {
            "type": "boolean"
          },
          "tags": {
            "shape": "Sl"
          },
          "buildSpec": {},
          "ttl": {},
          "displayName": {}
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "branch"
        ],
        "members": {
          "branch": {
            "shape": "S1c"
          }
        }
      }
    },
    "CreateDeployment": {
      "http": {
        "requestUri": "/apps/{appId}/branches/{branchName}/deployments"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "fileMap": {
            "type": "map",
            "key": {},
            "value": {}
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "fileUploadUrls",
          "zipUploadUrl"
        ],
        "members": {
          "jobId": {},
          "fileUploadUrls": {
            "type": "map",
            "key": {},
            "value": {}
          },
          "zipUploadUrl": {}
        }
      }
    },
    "CreateDomainAssociation": {
      "http": {
        "requestUri": "/apps/{appId}/domains"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "domainName",
          "subDomainSettings"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "domainName": {},
          "enableAutoSubDomain": {
            "type": "boolean"
          },
          "subDomainSettings": {
            "shape": "S1v"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "domainAssociation"
        ],
        "members": {
          "domainAssociation": {
            "shape": "S1z"
          }
        }
      }
    },
    "CreateWebhook": {
      "http": {
        "requestUri": "/apps/{appId}/webhooks"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {},
          "description": {}
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "webhook"
        ],
        "members": {
          "webhook": {
            "shape": "S2a"
          }
        }
      }
    },
    "DeleteApp": {
      "http": {
        "method": "DELETE",
        "requestUri": "/apps/{appId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "app"
        ],
        "members": {
          "app": {
            "shape": "Sx"
          }
        }
      }
    },
    "DeleteBranch": {
      "http": {
        "method": "DELETE",
        "requestUri": "/apps/{appId}/branches/{branchName}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "branch"
        ],
        "members": {
          "branch": {
            "shape": "S1c"
          }
        }
      }
    },
    "DeleteDomainAssociation": {
      "http": {
        "method": "DELETE",
        "requestUri": "/apps/{appId}/domains/{domainName}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "domainName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "domainName": {
            "location": "uri",
            "locationName": "domainName"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "domainAssociation"
        ],
        "members": {
          "domainAssociation": {
            "shape": "S1z"
          }
        }
      }
    },
    "DeleteJob": {
      "http": {
        "method": "DELETE",
        "requestUri": "/apps/{appId}/branches/{branchName}/jobs/{jobId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName",
          "jobId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "jobId": {
            "location": "uri",
            "locationName": "jobId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "jobSummary"
        ],
        "members": {
          "jobSummary": {
            "shape": "S2m"
          }
        }
      }
    },
    "DeleteWebhook": {
      "http": {
        "method": "DELETE",
        "requestUri": "/webhooks/{webhookId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "webhookId"
        ],
        "members": {
          "webhookId": {
            "location": "uri",
            "locationName": "webhookId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "webhook"
        ],
        "members": {
          "webhook": {
            "shape": "S2a"
          }
        }
      }
    },
    "GetApp": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "app"
        ],
        "members": {
          "app": {
            "shape": "Sx"
          }
        }
      }
    },
    "GetBranch": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/branches/{branchName}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "branch"
        ],
        "members": {
          "branch": {
            "shape": "S1c"
          }
        }
      }
    },
    "GetDomainAssociation": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/domains/{domainName}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "domainName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "domainName": {
            "location": "uri",
            "locationName": "domainName"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "domainAssociation"
        ],
        "members": {
          "domainAssociation": {
            "shape": "S1z"
          }
        }
      }
    },
    "GetJob": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/branches/{branchName}/jobs/{jobId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName",
          "jobId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "jobId": {
            "location": "uri",
            "locationName": "jobId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "job"
        ],
        "members": {
          "job": {
            "type": "structure",
            "required": [
              "summary",
              "steps"
            ],
            "members": {
              "summary": {
                "shape": "S2m"
              },
              "steps": {
                "type": "list",
                "member": {
                  "type": "structure",
                  "required": [
                    "stepName",
                    "startTime",
                    "status",
                    "endTime"
                  ],
                  "members": {
                    "stepName": {},
                    "startTime": {
                      "type": "timestamp"
                    },
                    "status": {},
                    "endTime": {
                      "type": "timestamp"
                    },
                    "logUrl": {},
                    "artifactsUrl": {},
                    "screenshots": {
                      "type": "map",
                      "key": {},
                      "value": {}
                    },
                    "statusReason": {},
                    "context": {}
                  }
                }
              }
            }
          }
        }
      }
    },
    "GetWebhook": {
      "http": {
        "method": "GET",
        "requestUri": "/webhooks/{webhookId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "webhookId"
        ],
        "members": {
          "webhookId": {
            "location": "uri",
            "locationName": "webhookId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "webhook"
        ],
        "members": {
          "webhook": {
            "shape": "S2a"
          }
        }
      }
    },
    "ListApps": {
      "http": {
        "method": "GET",
        "requestUri": "/apps"
      },
      "input": {
        "type": "structure",
        "members": {
          "nextToken": {
            "location": "querystring",
            "locationName": "nextToken"
          },
          "maxResults": {
            "location": "querystring",
            "locationName": "maxResults",
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "apps"
        ],
        "members": {
          "apps": {
            "type": "list",
            "member": {
              "shape": "Sx"
            }
          },
          "nextToken": {}
        }
      }
    },
    "ListBranches": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/branches"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "nextToken": {
            "location": "querystring",
            "locationName": "nextToken"
          },
          "maxResults": {
            "location": "querystring",
            "locationName": "maxResults",
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "branches"
        ],
        "members": {
          "branches": {
            "type": "list",
            "member": {
              "shape": "S1c"
            }
          },
          "nextToken": {}
        }
      }
    },
    "ListDomainAssociations": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/domains"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "nextToken": {
            "location": "querystring",
            "locationName": "nextToken"
          },
          "maxResults": {
            "location": "querystring",
            "locationName": "maxResults",
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "domainAssociations"
        ],
        "members": {
          "domainAssociations": {
            "type": "list",
            "member": {
              "shape": "S1z"
            }
          },
          "nextToken": {}
        }
      }
    },
    "ListJobs": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/branches/{branchName}/jobs"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "nextToken": {
            "location": "querystring",
            "locationName": "nextToken"
          },
          "maxResults": {
            "location": "querystring",
            "locationName": "maxResults",
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "jobSummaries"
        ],
        "members": {
          "jobSummaries": {
            "type": "list",
            "member": {
              "shape": "S2m"
            }
          },
          "nextToken": {}
        }
      }
    },
    "ListTagsForResource": {
      "http": {
        "method": "GET",
        "requestUri": "/tags/{resourceArn}"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn"
        ],
        "members": {
          "resourceArn": {
            "location": "uri",
            "locationName": "resourceArn"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "tags": {
            "shape": "Sl"
          }
        }
      }
    },
    "ListWebhooks": {
      "http": {
        "method": "GET",
        "requestUri": "/apps/{appId}/webhooks"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "nextToken": {
            "location": "querystring",
            "locationName": "nextToken"
          },
          "maxResults": {
            "location": "querystring",
            "locationName": "maxResults",
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "webhooks"
        ],
        "members": {
          "webhooks": {
            "type": "list",
            "member": {
              "shape": "S2a"
            }
          },
          "nextToken": {}
        }
      }
    },
    "StartDeployment": {
      "http": {
        "requestUri": "/apps/{appId}/branches/{branchName}/deployments/start"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "jobId": {},
          "sourceUrl": {}
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "jobSummary"
        ],
        "members": {
          "jobSummary": {
            "shape": "S2m"
          }
        }
      }
    },
    "StartJob": {
      "http": {
        "requestUri": "/apps/{appId}/branches/{branchName}/jobs"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName",
          "jobType"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "jobId": {},
          "jobType": {},
          "jobReason": {},
          "commitId": {},
          "commitMessage": {},
          "commitTime": {
            "type": "timestamp"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "jobSummary"
        ],
        "members": {
          "jobSummary": {
            "shape": "S2m"
          }
        }
      }
    },
    "StopJob": {
      "http": {
        "method": "DELETE",
        "requestUri": "/apps/{appId}/branches/{branchName}/jobs/{jobId}/stop"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName",
          "jobId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "jobId": {
            "location": "uri",
            "locationName": "jobId"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "jobSummary"
        ],
        "members": {
          "jobSummary": {
            "shape": "S2m"
          }
        }
      }
    },
    "TagResource": {
      "http": {
        "requestUri": "/tags/{resourceArn}"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "tags"
        ],
        "members": {
          "resourceArn": {
            "location": "uri",
            "locationName": "resourceArn"
          },
          "tags": {
            "shape": "Sl"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {}
      }
    },
    "UntagResource": {
      "http": {
        "method": "DELETE",
        "requestUri": "/tags/{resourceArn}"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "tagKeys"
        ],
        "members": {
          "resourceArn": {
            "location": "uri",
            "locationName": "resourceArn"
          },
          "tagKeys": {
            "location": "querystring",
            "locationName": "tagKeys",
            "type": "list",
            "member": {}
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {}
      }
    },
    "UpdateApp": {
      "http": {
        "requestUri": "/apps/{appId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "name": {},
          "description": {},
          "platform": {},
          "iamServiceRoleArn": {},
          "environmentVariables": {
            "shape": "S9"
          },
          "enableBranchAutoBuild": {
            "type": "boolean"
          },
          "enableBasicAuth": {
            "type": "boolean"
          },
          "basicAuthCredentials": {},
          "customRules": {
            "shape": "Sf"
          },
          "buildSpec": {},
          "enableAutoBranchCreation": {
            "type": "boolean"
          },
          "autoBranchCreationPatterns": {
            "shape": "Sq"
          },
          "autoBranchCreationConfig": {
            "shape": "Ss"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "app"
        ],
        "members": {
          "app": {
            "shape": "Sx"
          }
        }
      }
    },
    "UpdateBranch": {
      "http": {
        "requestUri": "/apps/{appId}/branches/{branchName}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "branchName"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "branchName": {
            "location": "uri",
            "locationName": "branchName"
          },
          "description": {},
          "framework": {},
          "stage": {},
          "enableNotification": {
            "type": "boolean"
          },
          "enableAutoBuild": {
            "type": "boolean"
          },
          "environmentVariables": {
            "shape": "S9"
          },
          "basicAuthCredentials": {},
          "enableBasicAuth": {
            "type": "boolean"
          },
          "buildSpec": {},
          "ttl": {},
          "displayName": {}
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "branch"
        ],
        "members": {
          "branch": {
            "shape": "S1c"
          }
        }
      }
    },
    "UpdateDomainAssociation": {
      "http": {
        "requestUri": "/apps/{appId}/domains/{domainName}"
      },
      "input": {
        "type": "structure",
        "required": [
          "appId",
          "domainName",
          "subDomainSettings"
        ],
        "members": {
          "appId": {
            "location": "uri",
            "locationName": "appId"
          },
          "domainName": {
            "location": "uri",
            "locationName": "domainName"
          },
          "enableAutoSubDomain": {
            "type": "boolean"
          },
          "subDomainSettings": {
            "shape": "S1v"
          }
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "domainAssociation"
        ],
        "members": {
          "domainAssociation": {
            "shape": "S1z"
          }
        }
      }
    },
    "UpdateWebhook": {
      "http": {
        "requestUri": "/webhooks/{webhookId}"
      },
      "input": {
        "type": "structure",
        "required": [
          "webhookId"
        ],
        "members": {
          "webhookId": {
            "location": "uri",
            "locationName": "webhookId"
          },
          "branchName": {},
          "description": {}
        }
      },
      "output": {
        "type": "structure",
        "required": [
          "webhook"
        ],
        "members": {
          "webhook": {
            "shape": "S2a"
          }
        }
      }
    }
  },
  "shapes": {
    "S9": {
      "type": "map",
      "key": {},
      "value": {}
    },
    "Sf": {
      "type": "list",
      "member": {
        "type": "structure",
        "required": [
          "source",
          "target"
        ],
        "members": {
          "source": {},
          "target": {},
          "status": {},
          "condition": {}
        }
      }
    },
    "Sl": {
      "type": "map",
      "key": {},
      "value": {}
    },
    "Sq": {
      "type": "list",
      "member": {}
    },
    "Ss": {
      "type": "structure",
      "members": {
        "stage": {},
        "framework": {},
        "enableAutoBuild": {
          "type": "boolean"
        },
        "environmentVariables": {
          "shape": "S9"
        },
        "basicAuthCredentials": {},
        "enableBasicAuth": {
          "type": "boolean"
        },
        "buildSpec": {}
      }
    },
    "Sx": {
      "type": "structure",
      "required": [
        "appId",
        "appArn",
        "name",
        "description",
        "repository",
        "platform",
        "createTime",
        "updateTime",
        "environmentVariables",
        "defaultDomain",
        "enableBranchAutoBuild",
        "enableBasicAuth"
      ],
      "members": {
        "appId": {},
        "appArn": {},
        "name": {},
        "tags": {
          "shape": "Sl"
        },
        "description": {},
        "repository": {},
        "platform": {},
        "createTime": {
          "type": "timestamp"
        },
        "updateTime": {
          "type": "timestamp"
        },
        "iamServiceRoleArn": {},
        "environmentVariables": {
          "shape": "S9"
        },
        "defaultDomain": {},
        "enableBranchAutoBuild": {
          "type": "boolean"
        },
        "enableBasicAuth": {
          "type": "boolean"
        },
        "basicAuthCredentials": {},
        "customRules": {
          "shape": "Sf"
        },
        "productionBranch": {
          "type": "structure",
          "members": {
            "lastDeployTime": {
              "type": "timestamp"
            },
            "status": {},
            "thumbnailUrl": {},
            "branchName": {}
          }
        },
        "buildSpec": {},
        "enableAutoBranchCreation": {
          "type": "boolean"
        },
        "autoBranchCreationPatterns": {
          "shape": "Sq"
        },
        "autoBranchCreationConfig": {
          "shape": "Ss"
        }
      }
    },
    "S1c": {
      "type": "structure",
      "required": [
        "branchArn",
        "branchName",
        "description",
        "stage",
        "displayName",
        "enableNotification",
        "createTime",
        "updateTime",
        "environmentVariables",
        "enableAutoBuild",
        "customDomains",
        "framework",
        "activeJobId",
        "totalNumberOfJobs",
        "enableBasicAuth",
        "ttl"
      ],
      "members": {
        "branchArn": {},
        "branchName": {},
        "description": {},
        "tags": {
          "shape": "Sl"
        },
        "stage": {},
        "displayName": {},
        "enableNotification": {
          "type": "boolean"
        },
        "createTime": {
          "type": "timestamp"
        },
        "updateTime": {
          "type": "timestamp"
        },
        "environmentVariables": {
          "shape": "S9"
        },
        "enableAutoBuild": {
          "type": "boolean"
        },
        "customDomains": {
          "type": "list",
          "member": {}
        },
        "framework": {},
        "activeJobId": {},
        "totalNumberOfJobs": {},
        "enableBasicAuth": {
          "type": "boolean"
        },
        "thumbnailUrl": {},
        "basicAuthCredentials": {},
        "buildSpec": {},
        "ttl": {},
        "associatedResources": {
          "type": "list",
          "member": {}
        }
      }
    },
    "S1v": {
      "type": "list",
      "member": {
        "shape": "S1w"
      }
    },
    "S1w": {
      "type": "structure",
      "required": [
        "prefix",
        "branchName"
      ],
      "members": {
        "prefix": {},
        "branchName": {}
      }
    },
    "S1z": {
      "type": "structure",
      "required": [
        "domainAssociationArn",
        "domainName",
        "enableAutoSubDomain",
        "domainStatus",
        "statusReason",
        "subDomains"
      ],
      "members": {
        "domainAssociationArn": {},
        "domainName": {},
        "enableAutoSubDomain": {
          "type": "boolean"
        },
        "domainStatus": {},
        "statusReason": {},
        "certificateVerificationDNSRecord": {},
        "subDomains": {
          "type": "list",
          "member": {
            "type": "structure",
            "required": [
              "subDomainSetting",
              "verified",
              "dnsRecord"
            ],
            "members": {
              "subDomainSetting": {
                "shape": "S1w"
              },
              "verified": {
                "type": "boolean"
              },
              "dnsRecord": {}
            }
          }
        }
      }
    },
    "S2a": {
      "type": "structure",
      "required": [
        "webhookArn",
        "webhookId",
        "webhookUrl",
        "branchName",
        "description",
        "createTime",
        "updateTime"
      ],
      "members": {
        "webhookArn": {},
        "webhookId": {},
        "webhookUrl": {},
        "branchName": {},
        "description": {},
        "createTime": {
          "type": "timestamp"
        },
        "updateTime": {
          "type": "timestamp"
        }
      }
    },
    "S2m": {
      "type": "structure",
      "required": [
        "jobArn",
        "jobId",
        "commitId",
        "commitMessage",
        "commitTime",
        "startTime",
        "status",
        "jobType"
      ],
      "members": {
        "jobArn": {},
        "jobId": {},
        "commitId": {},
        "commitMessage": {},
        "commitTime": {
          "type": "timestamp"
        },
        "startTime": {
          "type": "timestamp"
        },
        "status": {},
        "endTime": {
          "type": "timestamp"
        },
        "jobType": {}
      }
    }
  }
}